﻿import './custom.scss'
import * as d3 from "d3";
import jQuery from "jquery"
import Mustache from "mustache"
import axios from 'axios';

var jquery = require("jquery");
window.$ = window.jQuery = jquery;




// vimeo api end

$(document).ready(function () {

  function findObjectByKey(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
    return array;
  }

  d3.csv(
    "https://docs.google.com/spreadsheets/d/1hJRuBvx9rvAnjhh7ea4XUU-5QnGs-KN1wUo0d99uSzI/gviz/tq?tqx=out:csv&sheet=list",
    function (d) {
      return {
        video_id: d.video_id,
      };
    },
    function (data) {



      var template = $('#works-temp').html();
      var output = $('.works');





      //data.video_id


      var thumbnail = "";
      var videoID = "";
      var title = "";

      axios.get('https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com/' + data.video_id + '').then(function (result) {

        thumbnail = result.data.thumbnail_url; // LIST = , OR RETURN - no idea how to set list
        videoID = "https://vimeo.com/" + result.data.video_id + "";
        title = result.data.title; // LIST = , OR RETURN - no idea how to set list

        var data = {
          "Subject": "Template Engines",
          "works": [{
            "thumbnail": thumbnail,
            "id": videoID,
            "title": title
          }, ]
        };

        var result = Mustache.render(template, data);

        output.append(result);


      });








      // console.log(data);
    }
  );




});

console.clear();